export default "__VITE_ASSET__BfFCgXGe__"